import CustomModal from "common/components/CustomModal/CustomModal";
import {
	ModalBody,
	ModalHeader,
	ModalPanel,
} from "common/components/CustomModal/Modal/ModalFrame";
import * as React from "react";
import "../SuccessFailModal/SuccessFailModal.scss";
import Discord from "common/components/Discord/Discord";

export default function ErrorModal({
	message,
	errorId,
	detail,
	displayContactDiscord,
}) {
	if (typeof message !== "string" || !message.trim()) {
		message = "Something went wrong. Please try again.";
	}
	return (
		<>
			<CustomModal>
				<ModalPanel className="success-fail-modal fail">
					<ModalHeader>Error</ModalHeader>
					<ModalBody className="success-fail-section">
						<label>{message}</label>
						{errorId && (
							<label className="error-reference">Error id: {errorId}</label>
						)}
						{detail && <label className="error-detail">{detail}</label>}
						<br />
						{(displayContactDiscord ?? true) && (
							<>
								<label>
									If problem persists, please contact us on Discord:
								</label>
								<br />
								<Discord />
							</>
						)}
					</ModalBody>
				</ModalPanel>
			</CustomModal>
		</>
	);
}
